/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';

import {
  selectRequestState,
  sendRequest
} from 'mt-react-common/modules/tasks/common/reducers/execRefuseForm';

import InfoMaterialContent from '../../../InfoMaterials/InfoMaterialContent';
import OpacityPreLoader from '../../../Common/PreLoaders/OpacityPreLoader';

// eslint-disable-next-line react/prefer-stateless-function
class TasksExecRefuseForm extends Component {
  componentDidUpdate(prevProp) {
    if (
      prevProp.requestState.hasSuccessQuery !==
        this.props.requestState.hasSuccessQuery &&
      this.props.requestState.hasSuccessQuery
    ) {
      this.props.closeAllTabs();
    }
  }
  render() {
    const refuseConfirmId = `refuseConfirm${this.props.exec.id}`;
    return (
      <React.Fragment>
        <div
          aria-labelledby="myModalLabel"
          className="modal fade"
          role="dialog"
          tabIndex="-1"
          id={refuseConfirmId}
        >
          <div className="modal-dialog modal-gray modal-sm">
            <div className="modal-content">
              <div className="modal-header text-center">
                <a
                  aria-label="Close"
                  className="close close-black"
                  data-dismiss="modal"
                  href=""
                />
                <i className="fa fa-exclamation-triangle modal-icon" />
                <h4 className="modal-title">
                  <strong>{t('Подтверждение')}</strong>
                </h4>
              </div>
              <div className="modal-body text-center">
                {t('Вы действительно хотите отказаться от выполнения?')}
              </div>
              <div className="modal-footer">
                <a
                  className="btn btn-muted"
                  data-dismiss="modal"
                  href=""
                  type="button"
                >
                  {t('Отмена')}
                </a>
                <a
                  className="btn btn-danger"
                  data-dismiss="modal"
                  href=""
                  type="button"
                  onClick={() => this.props.sendRequest()}
                >
                  {t('Отказаться')}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-pane active">
          <div className="panel-footer pos-rel">
            {this.props.requestState.hasInProgress ? (
              <OpacityPreLoader />
            ) : null}
            <div className="alert alert-danger text-center m-b-15" role="alert">
              <InfoMaterialContent id={'exec_refuse'} />
            </div>
            <a
              className="btn btn-danger btn-block"
              data-toggle="modal"
              type="button"
              href={`#${refuseConfirmId}`}
            >
              {t('Отказаться от выполнения')}
            </a>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TasksExecRefuseForm.propTypes = {
  // IN
  closeAllTabs: PropTypes.func.isRequired,
  exec: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,

  // CONNECT
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, props.formReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () => dispatch(sendRequest(props.formReduceName, props.exec.id))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksExecRefuseForm)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsForms/TasksExecRefuseForm/TasksExecRefuseForm.js